import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';

const IconWithTitle = ({ title, icon }) => {
  return (
    <div title={title}>
      <FontAwesomeIcon icon={icon} />
    </div>
  );
};

export default IconWithTitle;
